import { render } from "./SzFormItemLayout.vue?vue&type=template&id=3d199a54&scoped=true"
import script from "./SzFormItemLayout.vue?vue&type=script&lang=ts"
export * from "./SzFormItemLayout.vue?vue&type=script&lang=ts"

import "./SzFormItemLayout.vue?vue&type=style&index=0&id=3d199a54&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3d199a54"

export default script